import React from "react";

function SvgXd(props) {
  let blur = "";
  if(props.activeMove){
    blur=40;
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      id="experience"
      width={props.width}
      height={props.height}
      viewBox="0 0 17.466 17.466"
    >
      <path
        id="Path_16444"
        data-name="Path 16444"
        d="M17.466,17.466H0V0H17.466Z"
        fill="#ff80e4"
      />
      <path
        id="Path_16445"
        data-name="Path 16445"
        d="M264.733,17.466H256V0h8.733Z"
        transform="translate(-247.267)"
        fill="#ff5ad4"
      />
      <path
        id="Path_16446"
        data-name="Path 16446"
        d="M45.419,45.419H30V30H45.419Z"
        transform="translate(-28.977 -28.977)"
        fill={"#7f1363"+blur}
      />
      <path
        id="Path_16447"
        data-name="Path 16447"
        d="M263.71,45.419H256V30h7.71Z"
        transform="translate(-247.267 -28.977)"
        fill={"#661054"+(blur-20)}
      />
      <path
        id="Path_16448"
        data-name="Path 16448"
        d="M111.689,181.6l1.449,2.161,1.441-2.161h1.22l-2.071,2.947,2.006,2.866h-1.22l-1.375-2.08-1.384,2.08h-1.228l2.006-2.866-2.071-2.947Z"
        transform="translate(-106.693 -175.405)"
        fill="#ff80e4"
      />
      <g
        id="Group_6605"
        data-name="Group 6605"
        transform="translate(8.733 6.031)"
      >
        <path
          id="Path_16449"
          data-name="Path 16449"
          d="M268.019,182.859a2.086,2.086,0,0,1-2.039-2.227,2.043,2.043,0,0,1,1.916-2.219,1.662,1.662,0,0,1,1.449.827V176.8h1.1v4.716c0,.115.161.322.254.327v.933a2.494,2.494,0,0,1-.467.057.707.707,0,0,1-.72-.8A1.715,1.715,0,0,1,268.019,182.859Zm.287-.933a1.177,1.177,0,0,0,1.04-.72v-1.023a1.38,1.38,0,0,0-1.105-.835,1.3,1.3,0,0,0,.065,2.579Z"
          transform="translate(-265.64 -176.8)"
          fill="#ff5ad4"
        />
        <path
          id="Path_16450"
          data-name="Path 16450"
          d="M256,181.6v.531l.373-.531Z"
          transform="translate(-256 -181.436)"
          fill="#ff5ad4"
        />
        <path
          id="Path_16451"
          data-name="Path 16451"
          d="M256,339.552h.308l-.308-.44Z"
          transform="translate(-256 -333.575)"
          fill="#ff5ad4"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgXd);
